﻿

$(document).ready(function () {
    var priceGrainOverviewPage = new PriceGrainOverviewPage();
    priceGrainOverviewPage.init();
    $(document).on("change", "select", function () {
        //Check whether option with value  exists
        var option = $("option[value='" + this.value + "']", this);
        if (option && option.length > 0) {
            option
                .attr("selected", true).siblings()
                .removeAttr("selected");
        }

    });
    // enhance table saw to make responsive table
    $(document).trigger("enhance.tablesaw");
});

var renderPriceGrainOverviewTable = function (title,data) {
    var printWindow = window.open("","_blank");
    printWindow.document.write('<html><head><title>'+title+'</title>');
    printWindow.document.write("<link rel=\"stylesheet\" href=\"/Static/dist/styles/styles.css\" type=\"text/css\" media=\"all\"/>");
    printWindow.document.write("<style type=\"text/css\">");
    printWindow.document.write("button.my-agreements__collapse-control:not(.is-active) {display: none !important;}");
    printWindow.document.write("button.my-agreements__collapse-control.is-active {padding-bottom: 0px !important;}");
    printWindow.document.write(".unloadingPanel {display: block !important;overflow: visible !important;height:auto !important;max-height: none !important;right: inherit;width:100% !important;}");
    printWindow.document.write(".collapse__target.is-active { display: block;padding-top: 0px !important;padding-right: 0px !important;padding-left: 0px !important;}");
    printWindow.document.write(".Terminrubrik:last-child { display: none !important;}");
    printWindow.document.write("table.tblPriceGrainOverviewResults tr:not(.price-grain-overview-favorite-row){display: none !important;}");
    printWindow.document.write("button.js-toggle:not(.expand-price-grain-overview-row) {display: none !important;}");
    printWindow.document.write("#priceAreaName {display: inline-block !important;margin-top: 10px !important;margin-bottom: 10px !important;}");
    printWindow.document.write('</style></head><body>');
    printWindow.document.write(data);
    printWindow.document.write('</body></html>');
    printWindow.document.close();
    setTimeout(function () {
        printWindow.focus();
        printWindow.print();
        printWindow.close();
    }, 3000);
    return true;
};

var printPriceGrainOverviewTable = function () {
    var btn = $('#printPriceGrainOverviewBtn');
    var overviewHeader = btn.attr('data-overviewHeader');
    var priceAreaHeader = btn.attr('data-priceAreaHeader');

    var priceArea = $('#price-grain-overview-areas-list li.selected').data('name');
    $("#priceAreaName > h4").html(priceAreaHeader+": "+priceArea);
    var title = overviewHeader + ' - ' + priceArea;
    renderPriceGrainOverviewTable(title,$('<div/>').append($("#printable-price-grain-overview-table").clone()).html());
};



var PriceGrainOverviewFunction = PriceGrainOverviewFunction || (function () {
    var blockUI = function () {
        $("#price-grain-overview-loader").show();
    };
    var unBlockUI = function () {
        $("#price-grain-overview-loader").hide();
    };

    var disableButtons = function () {
        $("#printPriceGrainOverviewBtn").addClass("disabled-btn");
    };
    var enableButtons = function () {
        $("#printPriceGrainOverviewBtn").removeClass("disabled-btn");
    };

    return {
        blockUI: blockUI,
        unBlockUI: unBlockUI,
        enableButtons: enableButtons,
        disableButtons: disableButtons
    };
})();

var PriceGrainOverviewPage = function () {
    var hidePriceGrainOverview = function () {
        $('.js-show-hide-price-grain-overview-result').hide();
    };

    var showPriceGrainOverview = function () {
        $('.js-show-hide-price-grain-overview-result').show();
    };

    var getCurrentlySelectedPriceAreaId = function () {
        return $('#price-grain-overview-areas-list').attr('data-value');
    };
    var setPriceGrainOverview = function () {
        $('button.js-toggle').each(function (i, priceGrainOverviewRow) {
            var control = $(priceGrainOverviewRow);
            if (control.hasClass('expand-price-grain-overview-row')){
                farmday.modules.toggle.show(control);
            }
        });
    };
    var requests = [];
    var fetchPriceGrainOverview = function () {
        hidePriceGrainOverview();
        PriceGrainOverviewFunction.disableButtons();
        PriceGrainOverviewFunction.blockUI();
        $.each(requests, function (index, request) {
            request.abort();
        });
        var tableResult = $("#price-grain-overview-result");
        requests = [];
        var priceGrainOverviewDefered = $.ajax({
            type: "POST",
            url: "/api/price-grain-overview/GetPriceGrainOverview",
            async: true,
            cache: false,
            data: JSON.stringify({ priceAreaId: getCurrentlySelectedPriceAreaId() }),
            contentType: "application/json; charset=utf-8",
            dataType: "html",
            success: function (priceGrainOverviewResult) {
                if (priceGrainOverviewResult && priceGrainOverviewResult.length > 0) {
                    tableResult.html(priceGrainOverviewResult);
                    /* little fade in effect */
                    tableResult.fadeIn('fast');
                }
                else {
                    tableResult.html("<div>Det finns inga priser för valt område och datum.</div>");
                }
            },
            error: function (jqXHR, status, exception) {
                console.error("Something went wrong with the AJAX request for fetching price grain overview!" + "</br>" + exception.message);
                tableResult.html("<h2>Det gick inte att hämta spannmålspriser</h2>");

            }
        });

        requests.push(priceGrainOverviewDefered);
        $.when.apply($, requests).then(function () {
            PriceGrainOverviewFunction.unBlockUI();
            PriceGrainOverviewFunction.enableButtons();
            setPriceGrainOverview();
            showPriceGrainOverview();
        });
    };
    var addPriceGrainOverviewEvents = function () {
        $('#price-grain-overview-areas-list .dropdown li a').on("click", function (e) {
            fetchPriceGrainOverview();
        });

        $('#printPriceGrainOverviewBtn').on("click", function (e) {
            printPriceGrainOverviewTable();
        });
    };
    var addPriceGrainOverviewFavorite = function (target,priceGrainOverviewFavorite) {
        PriceGrainOverviewFunction.blockUI();
        $.ajax({
            type: "POST",
            url: "/api/price-grain-overview/AddPriceGrainOverviewFavorite",
            async: true,
            cache: false,
            data: JSON.stringify({ priceGrainOverviewFavorite: priceGrainOverviewFavorite }),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response) {
                    target.addClass("active");
                    var targetRow = target.closest('tr');
                    targetRow.addClass('price-grain-overview-favorite-row');
                    var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegroupid') + ']');
                    var tblResult = $('#tblPriceGrainOverviewResults_' + target.data('pricegroupid'));
                    //add expand row if there is any favorite
                    if (parentRow && !parentRow.hasClass('expand-price-grain-overview-row')) {
                        parentRow.addClass('expand-price-grain-overview-row');
                    }
                    //add active icon to select all if all rows are favorite
                    if (parentRow && tblResult.find('tr.price-grain-overview-favorite-row').length == tblResult.find('tr').length) {
                        parentRow.find('button.js-price-grain-overview-favorite-all').addClass("active");
                    }
                }
            },
            error: function (response) {
                console.error("Något gick fel vid tilläggning av prislista översikt favorit.");
            },
            complete: function () {
                PriceGrainOverviewFunction.unBlockUI();
            }
        });
    }
    var removePriceGrainOverviewFavorite = function (target,priceGrainOverviewFavorite) {
        PriceGrainOverviewFunction.blockUI();
        $.ajax({
            type: "POST",
            url: "/api/price-grain-overview/RemovePriceGrainOverviewFavorite",
            async: true,
            cache: false,
            data: JSON.stringify({ priceGrainOverviewFavorite: priceGrainOverviewFavorite }),
            contentType: "application/json; charset=utf-8",
            success: function (response) {
                if (response) {
                    target.removeClass("active");
                    var targetRow = target.closest('tr');
                    targetRow.removeClass('price-grain-overview-favorite-row');
                    var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegroupid') + ']');
                    var hasFavoriteRows = $('#tblPriceGrainOverviewResults_' + target.data('pricegroupid')).find('tr.price-grain-overview-favorite-row').length > 0;
                    if (!hasFavoriteRows && parentRow.hasClass('expand-price-grain-overview-row')) {
                        parentRow.removeClass('expand-price-grain-overview-row');
                    }
                    //remove active class from select all
                    parentRow.find('button.js-price-grain-overview-favorite-all').removeClass("active");
                }
            },
            error: function (response) {
                console.error("Något gick fel vid tabort av prislista översikt favorit.");
            },
            complete: function() {
                PriceGrainOverviewFunction.unBlockUI();
            }
        });
    }
    var priceGrainOverviewFavoriteClickEvent = function () {
        $(document).on("click",".js-price-grain-overview-favorite",function (e) {
                e.stopPropagation();
                var priceGrainOverviewFavorite = {
                    PriceAreaId: getCurrentlySelectedPriceAreaId(),
                    PriceGroupId: $(this).data("pricegroupid"),
                    ItemNumber: $(this).data("itemnumber"),
                    Sort: $(this).data("sort")
                }
                if ($(this).hasClass("active")) {
                    removePriceGrainOverviewFavorite($(this),priceGrainOverviewFavorite);
                } else {
                    addPriceGrainOverviewFavorite($(this),priceGrainOverviewFavorite);
                }

            });

    }
    var addAllPriceGrainOverviewFavorites = function (target) {
        var priceGrainOverviewFavoritesToAdd = [];
        var controls = [];
        PriceGrainOverviewFunction.blockUI();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        $('#tblPriceGrainOverviewResults_' + target.data('pricegrainoverviewrowid')).find('tr:not(.price-grain-overview-favorite-row)').each(function (i, priceGrainOverviewRow) {
            var control = $(priceGrainOverviewRow).find('button.js-price-grain-overview-favorite');
            var priceGrainOverviewFavorite = {
                PriceAreaId: priceAreaId,
                PriceGroupId: control.data("pricegroupid"),
                ItemNumber: control.data("itemnumber"),
                Sort: control.data("sort")
            }
            controls.push(control);
            priceGrainOverviewFavoritesToAdd.push(priceGrainOverviewFavorite);
        });
        if (priceGrainOverviewFavoritesToAdd.length > 0) {
            $.ajax({
                type: "POST",
                url: "/api/price-grain-overview/AddAllPriceGrainOverviewFavorites",
                async: true,
                cache: false,
                data: JSON.stringify({ priceGrainOverviewFavorites: priceGrainOverviewFavoritesToAdd }),
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    if (response) {
                        target.addClass("active");
                        //adding active class and marking all child rows as favorite
                        for (var index = 0; index < controls.length; index++) {
                            controls[index].addClass('active');
                            var targetRow = controls[index].closest('tr');
                            targetRow.addClass('price-grain-overview-favorite-row');
                        }
                        //add expand row and open the child row container
                        var parentRow = $('button.js-toggle[data-toggle-target=#' + target.data('pricegrainoverviewrowid') + ']');
                        if (parentRow && !parentRow.hasClass('expand-price-grain-overview-row')) {
                            parentRow.addClass('expand-price-grain-overview-row');
                            farmday.modules.toggle.show(parentRow);
                        }
                    }
                },
                error: function (response) {
                    console.error("Något gick fel vid tilläggning av prislista översikt favorit.");
                },
                complete: function () {
                    PriceGrainOverviewFunction.unBlockUI();
                }
            });
        }
    }
    var removeAllPriceGrainOverviewFavorites = function (target) {
        var priceGrainOverviewFavoritesToRemove = [];
        var controls = [];
        PriceGrainOverviewFunction.blockUI();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        $('#tblPriceGrainOverviewResults_' + target.data('pricegrainoverviewrowid')).find('tr.price-grain-overview-favorite-row').each(function (i, priceGrainOverviewRow) {
            var control = $(priceGrainOverviewRow).find('button.js-price-grain-overview-favorite');
            var priceGrainOverviewFavorite = {
                PriceAreaId: priceAreaId,
                PriceGroupId: control.data("pricegroupid"),
                ItemNumber: control.data("itemnumber"),
                Sort: control.data("sort")
            }
            controls.push(control);
            priceGrainOverviewFavoritesToRemove.push(priceGrainOverviewFavorite);
        });
        if (priceGrainOverviewFavoritesToRemove.length > 0) {
            $.ajax({
                type: "POST",
                url: "/api/price-grain-overview/RemoveAllPriceGrainOverviewFavorites",
                async: true,
                cache: false,
                data: JSON.stringify({ priceGrainOverviewFavorites: priceGrainOverviewFavoritesToRemove }),
                contentType: "application/json; charset=utf-8",
                success: function (response) {
                    if (response) {
                        target.removeClass("active");

                        for (var index = 0; index < controls.length; index++) {
                            controls[index].removeClass('active');
                            var targetRow = controls[index].closest('tr');
                            targetRow.removeClass('price-grain-overview-favorite-row');
                        }
                        var tblResult = $('#tblPriceGrainOverviewResults_' + target.data('pricegrainoverviewrowid'));
                        //if there are no more favorite rows then remove the expand row class
                        var hasFavoriteRows = tblResult.find('tr.price-grain-overview-favorite-row').length > 0;
                        if (!hasFavoriteRows && target.hasClass('expand-price-grain-overview-row')) {
                            target.removeClass('expand-price-grain-overview-row');
                        }
                    }
                },
                error: function (response) {
                    console.error("Något gick fel vid tilläggning av prislista översikt favorit.");
                },
                complete: function () {
                    PriceGrainOverviewFunction.unBlockUI();
                }
            });
        }
    }
    var priceGrainOverviewFavoriteAllClickEvent = function () {
        $(document).on("click",".js-price-grain-overview-favorite-all",function(e) {
                e.stopPropagation();
                if ($(this).hasClass("active")) {
                    removeAllPriceGrainOverviewFavorites($(this));
                } else {
                    addAllPriceGrainOverviewFavorites($(this));
                }
            });
    }
    var init = function () {
        addPriceGrainOverviewEvents();
        priceGrainOverviewFavoriteClickEvent();
        priceGrainOverviewFavoriteAllClickEvent();
        var priceAreaId = getCurrentlySelectedPriceAreaId();
        if (priceAreaId && priceAreaId.length > 0) {
            fetchPriceGrainOverview();
        }
    };
    return {
        init: init
    };
};